export enum Role {
    COMPANY = 'COMPANY',
    EMPLOYEE = 'EMPLOYEE',
    FREELANCE = 'FREELANCE',
    ROWNER = 'ROWNER',
    RIDER = 'RIDER',
    FIXMEUP = 'FIXMEUP',
    AGENT = 'AGENT',
    STAFF = 'STAFF',
    CAB_RIDER = 'CAB_RIDER'
}   

export type Service_Roles =
    | Role.COMPANY
    | Role.EMPLOYEE
    | Role.FREELANCE
    | Role.ROWNER
    | Role.RIDER
    | Role.FIXMEUP
    | Role.AGENT
    | Role.STAFF
    | Role.CAB_RIDER;

export const Service_RolesArray = ['COMPANY', 'EMPLOYEE', 'FREELANCE', 'ROWNER', 'RIDER', 'FIXMEUP', 'AGENT', 'STAFF', 'CAB_RIDER'];

/** Repair request (quotation) flow. */
export const Repair_RolesArray = ['FREELANCE', 'COMPANY', 'EMPLOYEE'];

/** Types with no dedicated flow on this portal; they only get Help, FAQs and Legal. */
export const Minimal_RolesArray = ['FIXMEUP', 'AGENT', 'STAFF', 'CAB_RIDER'];

export const Product_RolesArray = [];
